const DEFAULT_MAX_SIZE_BYTES = 5 * 1024 * 1024;

interface ValidateOptions {
  allowedTypes: string[];
  maxSizeBytes?: number;
}

interface ValidationResult {
  valid: boolean;
  error?: string;
}

const formatTypeLabel = (allowedTypes: string[]): string => {
  const subtypes = allowedTypes
    .map((type) => type.split('/')[1]?.toUpperCase())
    .filter((label): label is string => Boolean(label));
  const unique = Array.from(new Set(subtypes));
  if (unique.length <= 1) {
    return unique[0] ?? '';
  }
  const last = unique[unique.length - 1];
  return `${unique.slice(0, -1).join(', ')}, or ${last}`;
};

export const validateImageFile = (file: File, options: ValidateOptions): ValidationResult => {
  const maxSize = options.maxSizeBytes ?? DEFAULT_MAX_SIZE_BYTES;
  const maxMb = Math.round(maxSize / (1024 * 1024));

  if (file.size > maxSize) {
    return { valid: false, error: `File must be less than ${maxMb}MB` };
  }
  if (!options.allowedTypes.includes(file.type)) {
    return { valid: false, error: `File must be ${formatTypeLabel(options.allowedTypes)}` };
  }
  return { valid: true };
};
